import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {IdexService} from 'app/idex.service';

@Component({
   selector: 'app-activate',
   templateUrl: './activate.component.html',
   styleUrls: ['./activate.component.css']
})
export class ActivateComponent implements OnInit {
   errorMessage: string;
   activateKey: string;
   device: string;
   constructor(private route: ActivatedRoute, private routeNav: Router, private service: IdexService) {
   }

   ngOnInit(): void {
      let activateKey = '';
      this.route.queryParams.subscribe(params => {
         activateKey = params['key'];
      });
      this.route.params.forEach((params: Params) => {
         this.device = params['device'];
      });
      this.checkDevice('idex://activate?key=' + activateKey, activateKey);
   }

   checkDevice(path, activateKey) {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search('iphone') > -1 && this.device === 'mobile') {
         window.location.href = path;
         setTimeout(function() {
            window.location.href = 'https://itunes.apple.com/app/zdox/id1436468541';
         }, 5000);
      } else if (userAgent.search('android') > -1 && this.device === 'mobile') {
         window.location.href = path;
         setTimeout(function () {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.ginkgosoft.idex';
         }, 1000);
      } else {
         setTimeout(() => {
            const browserInfo = this.service.getBrowserInfo();
            const location = this.service.location;
            this.service.post('/activate?key=' + activateKey + '&browserInfo=' + browserInfo + '&location=' + location)
               .subscribe((data: any) => {
                  this.service.setUser(data);
                  window.location.href = 'index.html';
            }, error => {
               this.errorMessage = error;
               this.routeNav.navigate(['/login']);
            });
         }, 500);
      }
   }
}
